<template>
	<div style="display: inline-block" :class="btClass" v-if="componentShow">
		<!--<el-button :type="type" :class="btClass" @click="exportBtFun" v-if="showBt">{{text}}</el-button>-->
		<el-button :type="type" :class="btClass" @click="exportBtFun" v-if="showBt">{{text}}</el-button>
		<el-dropdown  :type="type"  @command="exportExcel" v-else>
			<el-button :type="type" :class="btClass">
				{{text}}<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown" style="max-height: 400px;overflow-y: auto;" class="export-dropdown" :style="{width : dropdownMenuWidth+'px'}">
				<el-dropdown-item  v-for="(item,index) in tempList" :key="index" :command="item" :divided="item.divided">{{item.tmpName}}</el-dropdown-item>
				<el-dropdown-item  v-for="(item,index) in customTmps" :key="item.tmpName" :command="item" :divided="index === 0">{{item.tmpName}}</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>

		<!--<el-button :type="type" @click="exportDialog = true"  :class="btClass" :disabled="disabled">{{text}}</el-button>-->
		<el-dialog v-dialogDrag :title="$t(i18nPage+'Excel自定义导出')" width="720px" :close-on-click-modal="false" :append-to-body="appendToBody"
							 :visible.sync="exportDialog" >
			<div class="dialog-content dialog-content-medium2">
				<el-form label-position="top" ref="exportform" :model="exportform">
					<el-row :gutter=8>
						<el-col :span=12>
							<el-form-item :label="$t(i18nPage+'可选格式')" prop="exportUsertmpId">
								<call-table ref="userTmpCallTable" table-name="bas_export_basetmp" v-model="exportUsertmpId"
														:default-extra="typeNo" @change="userTmpChange"></call-table>
								<!--<el-input />-->
							</el-form-item>
						</el-col>
						<el-col :span=8 class="colbutton">
							<el-button type="primary" @click="saveTmp" :loading="saveLoading"  class="zm-button2">{{$t(i18nPage+'保存')}}</el-button>
							<el-button type="primary" @click="resaveTmp" :loading="resaveLoading" class="zm-button3">{{$t(i18nPage+'另存为')}}</el-button>
							<!--<el-button type="primary" @click="userTmpExport" :loading="userTmpLoading">通用模版导出</el-button>-->
						</el-col>
						<el-col :span=4 class="colbutton">
							<el-row type="flex" justify="end">
								<el-button type="danger" @click="delTmp"  :loading="delLoading" class="zm-button2">{{$t(i18nPage+'删除')}}</el-button>
							</el-row>
						</el-col>
					</el-row>

					<el-container>
						<el-aside width="280px">
							<div class="title">
								<span class="title-text">{{$t(i18nPage+'待导出列')}}</span>
							</div>
							<common-table ref="mainTable" :col="col"  @row-dblclick="mainDblclick" :single-select=false
														:get-params="getTableParam" :table-height=350 :is-auto=false :start-query=false>
							</common-table>
						</el-aside>
						<el-main>
							<el-container>
								<el-aside width="100px" style="text-align: center;padding-top: 100px">
									<div>
										<el-button type="primary" @click="upRow" style="width: 35px;padding: 6px 0;text-align: center;">↑</el-button>
									</div>
									<div style="margin-top: 12px">
										<el-button type="primary" @click="downRow" style="width: 35px;padding: 6px 0;text-align: center;">↓</el-button>
									</div>
									<div style="margin-top: 38px">
										<el-button type="primary" @click="chooiesCol" style="width: 35px;padding: 6px 0;text-align: center;">></el-button>
									</div>
									<div style="margin-top: 12px">
										<el-button type="primary" @click="chooiesColAll" style="width: 35px;padding: 6px 0;text-align: center;">>></el-button>
									</div>
									<div style="margin-top: 12px">
										<el-button type="primary" @click="cancelColAll" style="width: 35px;padding: 6px 0;text-align: center;"><<</el-button>
									</div>
									<div style="margin-top: 12px">
										<el-button type="primary" @click="cancelCol" style="width: 35px;padding: 6px 0;text-align: center;"><</el-button>
									</div>
								</el-aside>
								<el-main>
									<div class="title">
										<span class="title-text">{{$t(i18nPage+'导出列')}}</span>
									</div>
									<common-table ref="detailTable" :col="col" :startQuery=false @row-dblclick="detailDblclick"
																:single-select=false :get-params="getTableParam" :table-height=350 :is-auto=false>
									</common-table>
								</el-main>
							</el-container>
						</el-main>
					</el-container>
					<div class="dialog-btn">
						<el-row :gutter=8>
							<el-col :span=12 style="text-align: left">
								<el-button type=primary @click="tableColExport" :loading="tableColLoading" >{{$t(i18nPage+'导出可视列')}}</el-button>
							</el-col>
							<el-col :span=12>
								<el-button type=primary @click="colExport" :loading="colLoading" class="zm-button2">{{$t(i18nPage+'导出')}}</el-button>
								<el-button type=info @click="exportDialog = false" class="zm-button2">{{$t(i18nPage+'取消')}}</el-button>
							</el-col>
						</el-row>
						<p style="color: red;float:left;margin-top:5px">{{$t(i18nPage+'直接导出表格中可以看到的所有列')}}</p>
					</div>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";

export default {
	components: {ElRow},
	name: "ZmBaseExport",
	props: {
		beanName:{
			type:String,
			required:true
		},
		customQuery:{
			type:Boolean,
			default:false
		},
		getTableCols:{
			type:Function,
			required:true
		},
		type:{
			type:String,
			default:'primary'
		},
		btClass:{
			type:String,
			// default:'zm-button2'
		},
		text:{
			type:String,
			required:true
		},
		method:{
			type:String,
			default:'post'
		},
		getParams:{
			type:Function,
			required:true
		},
		beforeClick:{
			type:Function
		},
		disabled:{
			type:Boolean,
			default:false
		},
		isAsynch:{
			type:Number,
			default:0
		},
		typeNo:{
			type:String,
			required:true
		},
		getFieldUrl:{
			type:String,
			default:'bas/exportField/detail/list'
		},
		dropdownMenuWidth:{
			type:Number,
			default:160
		},
		customTmps: {
			type: Array
		},
		filterData: Function,
		exportName:{
			type:String
		},
		appendToBody:{
			type:Boolean,
			default:false
		}
	},
	beforeCreate() {
		this.i18nPage = 'component.ZmBaseExport.';
	},
	data(){
		return {
			i18nPage : 'component.ZmBaseExport.',
			componentShow:true,
			saveLoading:false,
			resaveLoading:false,
			delLoading:false,
			exportDialog:false,
			userTmpLoading:false,
			tmpLoading:false,
			colLoading:false,
			tableColLoading:false,
			exportform:{
				customQuery:false,
				beanName:'',
				tempId:null,
				exportType:'',
				isSave:0,
				tempName:'',
				isAsynch:0,
				colStr:'',
				paramStr:'',
				fileType:''
			},
			exportUsertmpId:null,
			exportTmpId:null,
			col:[
				{value: 'fieldName',text: this.i18nPage+'列名称',width: 150}
			],
			userTmpObj:null,
			tmpObj:null,
			tempList:[],
			copyTableList:[],
			reloadMainTable:false,
			showBt:true
		}
	},
	computed:{

	},
	methods: {
		exportBtFun(){
			this.exportExcel({type:'col',tmpName: this.$t(this.i18nPage +'自定义导出'),divided:true});
		},
		exportExcel(obj){
			if(this.beforeClick){
				this.beforeClick().then(() => {
					this.exportExcel2(obj);
				}).catch(() => {});
			}else{
				this.exportExcel2(obj);
			}
		},
		exportExcel2(obj){
			if(obj.type == 'col') {
				let cols = this.getTableCols();
				if(cols && cols.length > 0){
					let mainTableData = [];
					this.copyTableList = [];
					cols.forEach((col,index) => {
						mainTableData.push({
							fieldName:this.$t(col.text),
							fieldNo:col.value
						});
						this.copyTableList.push({
							fieldName:this.$t(col.text),
							fieldNo:col.value
						});
					})
					this.exportDialog = true;
					this.$nextTick(() => {
						this.exportUsertmpId = null;
						this.$refs['detailTable'].setTableData([]);
						this.$refs['mainTable'].setTableData(mainTableData);
					});
				}else{
					this.$util.show(this.$t(this.i18nPage+'获取表格列信息失败'),1)
				}
			} else if (obj.type == 'custom'){
				this.$emit('custom-change',obj);
			}else{
				switch (obj.type) {
					case 'userTmp':
						this.exportform.exportType = 'standard';
						break;
					case 'tmp':
						this.exportform.exportType = 'desig';
						break;
				}
				this.exportform.tempId = obj.id;
				this.exportform.tempName = obj.tmpName;
				this.exportform.isSave = 0;
				this.exportform.isAsynch = this.isAsynch;
				this.exportform.colStr = '';
				this.exportform.fileType = obj.fileType;
				this.requestFun(obj.type);
			}

		},
		requestFun(type){
			var params = this.getParams();
			if(params){
				this.exportform.paramStr = JSON.stringify(params.params);
				this.exportform.beanName = this.beanName;
				this.exportform.customQuery = this.customQuery;
				if(this.isAsynch === 0){
					this.$httpService.download('cmn/export/export',Object.assign({filename:this.exportform.tempName}, this.exportform)).then(res =>{
						this.setLoading(type,false);
					}).catch(res => {
						this.setLoading(type,false);
					});
				} else {
					this.$httpService.post('cmn/export/export',this.exportform).then(res =>{
						let is_type = JSON.parse(sessionStorage.getItem('sysType'));
						if(is_type == 'oms'){
							this.$util.show(this.$t(this.i18nPage+`创建导出任务成功，请在导出列表中进行下载`));
						}else{
							this.$util.show(this.$t(this.i18nPage+"创建导出任务成功"));
						}
						this.$tmsglobal.addExcelJob({excelName:res.excelName,id:res.id});
						this.setLoading(type,false);
					}).catch(res => {
						if(res && res.result_code == 401004){
							this.$tmsglobal.initExcelJobByUser();
						}
						if (res && res.message){
							this.$util.show(res.message,1);
						} else if (res && res.solution) {
							this.$util.show(res.solution,1);
						} else {
							this.$util.show(this.$t(this.i18nPage+"创建导出任务失败"),1);
						}
						this.setLoading(type,false);
					});
				}

			}
		},
		setLoading(type,loading){
			switch (type) {
				case 'userTmp':
					this.userTmpLoading = loading;
					break;
				case 'tmp':
					this.tmpLoading = loading;
					break;
				case 'col':
					this.colLoading = loading;
					break;
				case 'tableCol':
					this.tableColLoading = loading;
					break;
			}
		},
		getTableParam(){
			return {
				url:this.getFieldUrl,
				params:{str:this.typeNo}
			}
		},
		upRow(){
			let tableData = this.$refs.detailTable.getTableData();
			if(tableData && tableData.length > 0){
				let selRows = this.$refs.detailTable.getSeleteRow();
				if(!selRows || selRows.length == 0){
					this.$util.show(this.$t(this.i18nPage+"请选择数据"),1);
					return;
				}
				if(selRows.length > 1){
					this.$util.show(this.$t(this.i18nPage+"请选择一条数据"),1);
					return;
				}
				let rowIndex = tableData.indexOf(selRows[0]);
				if(rowIndex === 0){
					this.$util.show(this.$t(this.i18nPage+"已经是列表中第一条数据"),1);
					return;
				}

				this.$refs.detailTable.setTableData(this.sortArr(tableData, rowIndex, rowIndex - 1));
			}else{
				this.$util.show(this.$t(this.i18nPage+"请选择导出列"),1);
			}
		},
		downRow(){
			let tableData = this.$refs.detailTable.getTableData();
			if(tableData && tableData.length > 0){
				let selRows = this.$refs.detailTable.getSeleteRow();
				if(!selRows || selRows.length == 0){
					this.$util.show(this.$t(this.i18nPage+"请选择数据"),1);
					return;
				}
				if(selRows.length > 1){
					this.$util.show(this.$t(this.i18nPage+"请选择一条数据"),1);
					return;
				}
				let rowIndex = tableData.indexOf(selRows[0]);
				if(rowIndex === (tableData.length - 1)){
					this.$util.show(this.$t(this.i18nPage+"已经是列表中最后一条数据"),1);
					return;
				}

				this.$refs.detailTable.setTableData(this.sortArr(tableData, rowIndex, rowIndex + 1));
			}else{
				this.$util.show(this.$t(this.i18nPage+"请选择导出列"),1);
			}
		},
		sortArr(arr, index1, index2){
			arr[index1] = arr.splice(index2,1,arr[index1])[0]
			return arr
		},
		mainDblclick(row){
			this.$refs.mainTable.deleteRow(row);
			this.$refs.detailTable.appendRow(row);
		},
		detailDblclick(row){
			this.$refs.mainTable.appendRow(row);
			this.$refs.detailTable.deleteRow(row);
		},
		chooiesCol(){
			let rows = this.$refs.mainTable.getSeleteRow();
			if(rows){
				this.$refs.mainTable.deleteRows(rows);
				this.$refs.detailTable.appendRows(rows);
			}
		},
		chooiesColAll(){
			let rows = this.$refs.mainTable.getTableData();
			// console.log(rows)
			if(rows && rows.length > 0){
				this.$refs.mainTable.setTableData([]);
				this.$refs.detailTable.appendRows(rows);
			}
		},
		cancelColAll(){
			let rows = this.$refs.detailTable.getTableData();
			// console.log(rows)
			if(rows && rows.length > 0){
				this.$refs.mainTable.appendRows(rows);
				this.$refs.detailTable.setTableData([]);
			}
		},
		cancelCol(){
			let rows = this.$refs.detailTable.getSeleteRow();
			if(rows){
				this.$refs.mainTable.appendRows(rows);
				this.$refs.detailTable.deleteRows(rows);
			}
		},
		saveTmp(){
			if(!this.exportUsertmpId){
				this.$util.show(this.$t(this.i18nPage+'请选择通用模版'),1);
				return;
			}
			let detailTableData = this.$refs.detailTable.getTableData();
			if(!detailTableData || detailTableData.length == 0){
				this.$util.show(this.$t(this.i18nPage+'请选择导出列'),1);
				return;
			}
			let that = this;
			this.$util.confirm(this.$t(this.i18nPage+'是否对模版字段进行修改'),this.$t(this.i18nPage+'提示')).then(() =>{
				that.saveLoading = true;
				that.$httpService.post('bas/exportBasetmpField/modify',{
					tmpId:that.exportUsertmpId,
					tmpFields:JSON.stringify(detailTableData)
				}).then(res => {
					that.saveLoading = false;
					that.$util.show(this.$t(this.i18nPage+'模版保存成功'));
				}).catch(() => {
					that.saveLoading = false;
					that.$util.show(this.$t(this.i18nPage+'模版保存失败'),2);
				});
				// this.$util.show('修改');
			}).catch(() => {
				this.$util.show(this.$t(this.i18nPage+'取消修改'),1);
			})
		},
		resaveTmp(){
			let detailTableData = this.$refs.detailTable.getTableData();
			if(!detailTableData || detailTableData.length == 0){
				this.$util.show(this.$t(this.i18nPage+'请选择导出列'),1);
				return;
			}
			let that = this;
			this.$prompt(this.$t(this.i18nPage+'请输入模版名称'), this.$t(this.i18nPage+'提示'), {
				confirmButtonText: this.$t(this.i18nPage+'确定'),
				cancelButtonText: this.$t(this.i18nPage+'取消')
			}).then(({ value }) => {
				that.resaveLoading = true;
				that.$httpService.post('bas/exportBasetmp/add',{
					typeNo:that.typeNo,
					tmpName:value,
					fieldsStr:JSON.stringify(detailTableData)
				}).then(res => {
					that.resaveLoading = false;
					that.cleanAndReloadCalltable();
					that.exportUsertmpId = res;
					that.$util.show(this.$t(this.i18nPage+'模版另存为成功'));
				}).catch(() => {
					that.resaveLoading = false;
					that.$util.show(this.$t(this.i18nPage+'模版另存为失败'),2);
				});
				// this.$util.show('另存为：'+value);
			}).catch(() => {
				this.$util.show(this.$t(this.i18nPage+'取消另存为'));
			});
		},
		delTmp(){
			if(!this.exportUsertmpId){
				this.$util.show(this.$t(this.i18nPage+'请选择通用模版'),1);
				return;
			}
			let that = this;
			this.$util.confirm(this.$t(this.i18nPage+'是否删除此模版'),this.$t(this.i18nPage+'提示')).then(() =>{
				that.delLoading = true;
				that.$httpService.post('bas/exportBasetmp/del',{
					id:this.exportUsertmpId
				}).then(res => {
					that.delLoading = false;
					that.exportUsertmpId = null;
					that.$refs.mainTable.setTableData(this.copyTableList.slice(0));
					that.$refs.detailTable.setTableData([]);
					that.cleanAndReloadCalltable();
					that.$util.show(this.$t(this.i18nPage+'模版删除成功'));
				}).catch(() => {
					that.delLoading = false;
					that.$util.show(this.$t(this.i18nPage+'模版删除失败'),2);
				});
			}).catch(() => {
				// this.$util.show('取消删除',1);
			})
		},
		colExport(){
			var detailTableData = this.$refs.detailTable.getTableData();
			if(!detailTableData || detailTableData.length == 0){
				this.$util.show(this.$t(this.i18nPage+'请选择导出列'),1);
				return;
			}
			this.exportform.tempId = undefined;
			this.exportform.exportType = 'standard';
			this.exportform.tempName =  this.exportName || this.typeNo;
			this.exportform.isAsynch = this.isAsynch;
			this.exportform.colStr = JSON.stringify(detailTableData);
			this.exportform.isSave = 0;
			this.setLoading('col',true);
			this.requestFun('col');
		},
		tableColExport(){
			let cols = this.getTableCols();
			if(cols && cols.length > 0){
				let mainTableData = [];
				cols.forEach((col,index) => {
					mainTableData.push({
						fieldName:this.$t(col.text),
						fieldNo:col.value
					});
				});
				this.exportform.tempId = undefined;
				this.exportform.exportType = 'standard';
				this.exportform.tempName =  this.exportName || this.typeNo;
				this.exportform.isAsynch = this.isAsynch;
				this.exportform.colStr = JSON.stringify(mainTableData);
				this.exportform.isSave = 0;
				this.setLoading('tableCol',true);
				this.requestFun('tableCol');
			}else{
				this.$util.show(this.$t(this.i18nPage+'获取表格列信息失败'),1)
			}
		},
		//用户模版选择回调
		userTmpChange(row){
			this.userTmpObj = row;
			if(row && row.id){
				this.$httpService.get('bas/exportBasetmpField/list',{id:row.id}).then(res => {
					if(res && res.length > 0){
						let fieldNos = [];
						let tableList = [];
						res.forEach((tmpfiele,index) => {
							fieldNos.push(tmpfiele.fieldNo)
						});

						this.copyTableList.forEach((row ,index) => {
							if(fieldNos.indexOf(row.fieldNo) == -1){
								tableList.push(row)
							}
						});
						this.$refs['mainTable'].setTableData(tableList);
						this.$refs['detailTable'].setTableData(res)

					}else{
						this.$refs['mainTable'].setTableData(this.copyTableList.slice(0));
						this.$refs['detailTable'].setTableData([]);
					}
				});
			}else{
				this.$refs['mainTable'].setTableData(this.copyTableList.slice(0));
				this.$refs['detailTable'].setTableData([]);
			}
		},
		//指定模版选择回调
		tmpChange(row){
			this.tmpObj = row;
		},
		cleanAndReloadCalltable(){
			this.$refs['userTmpCallTable'].getTableList(this.typeNo);
		}
	},
	created(){
		// let that = this;

		this.$global.getTransferTable('bas_export_basetmp',this.typeNo).then(usertmpres => {
			if(usertmpres && usertmpres.length > 0){
				usertmpres.forEach((usertmp, index) => {
					this.tempList.push(Object.assign({type:'userTmp',divided:false}, usertmp));
				});
			}
			this.tempList.push({type:'col',tmpName:this.$t(this.i18nPage +'自定义导出'),divided:true})
			this.showBt = this.tempList.length <= 1 && (!this.customTmps || this.customTmps.length === 0);
		});

		/*this.$global.getTransferTable('bas_export_basetmp',this.typeNo).then(tmpres => {
				if(tmpres && tmpres.length > 0){
						tmpres.forEach((tmp, index) => {
								that.tempList.push(Object.assign({type:'tmp',divided:false}, tmp));
						});
				}

		});*/
	},
	beforeDestroy(){
		this.componentShow = false;
	}

};
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// ../../src/components/ZmBaseExport/index.vue